import { createSelector } from 'reselect';
import { initialState, LoadingState } from './reducer';

const loadingSlice = (state: LoadingState) => state.loading || initialState;

export const isLoading = createSelector([loadingSlice], (slice: LoadingState) => Object.keys(slice).some(key => slice[key].isLoading));

export const selectWidgetsLoading = createSelector([loadingSlice], (slice: LoadingState) => slice.widgets.isLoading);

export const selectAccountsLoading = createSelector([loadingSlice], (slice: LoadingState) => slice.account.isLoading);

export const selectSSOLoading = createSelector([loadingSlice], (slice: LoadingState) => slice.sso.isLoading);

export const selectProgressWidth = createSelector([selectWidgetsLoading, selectAccountsLoading], (widgets, accounts) => {
    const howMany = [widgets, accounts].filter(e => !e).length;
    if (howMany === 1) {
        return '90%';
    } else if (howMany === 2) {
        return '100%';
    } else {
        return '0';
    }
});
